/**
 * Tools whose next shape has color, size, font, dash, or arrowhead styles.
 * Frame is omitted: its color is not a style prop unless explicitly enabled.
 */
export const STYLE_PANEL_EXPAND_TOOLS = new Set([
  'text',
  'arrow',
  'geo',
  'note',
  'draw',
  'highlight',
  'line',
]);

/**
 * Shape types that contribute those same styles when selected.
 * Pins, images, embeds, bookmarks, videos, and frames do not.
 */
export const STYLE_PANEL_EXPAND_SHAPE_TYPES = new Set([
  'text',
  'arrow',
  'geo',
  'note',
  'draw',
  'highlight',
  'line',
]);

/**
 * The top-right style panel should be expanded only while style applies:
 * the text/arrow/geo/note/draw/highlight/line tool is active, or the selection
 * (including shapes inside a group) has shared styles.
 *
 * @param {{
 *   toolId?: string,
 *   sharedStyleCount?: number,
 *   selectedShapeTypes?: string[],
 * }} state
 */
export function boardStylePanelShouldExpand(state) {
  if (!state) return false;
  if (STYLE_PANEL_EXPAND_TOOLS.has(state.toolId)) return true;
  if (typeof state.sharedStyleCount === 'number') return state.sharedStyleCount > 0;
  const types = Array.isArray(state.selectedShapeTypes) ? state.selectedShapeTypes : [];
  return types.some(type => STYLE_PANEL_EXPAND_SHAPE_TYPES.has(type));
}

/** Snapshot the editor fields that decide whether the style panel is expanded. */
export function readBoardStylePanelState(editor) {
  const toolId = editor?.getCurrentToolId?.() || 'select';
  const selectedIds = editor?.getSelectedShapeIds?.() || [];
  const sharedStyleCount = editor?.getSharedStyles?.()?.size ?? 0;
  const expand = boardStylePanelShouldExpand({ toolId, sharedStyleCount });
  return {
    expand,
    key: `${expand ? '1' : '0'}|${toolId}|${selectedIds.join(',')}`,
  };
}
